import styled from 'styled-components';
import { Close } from 'styled-icons/material/Close';

export const Overlay = styled.div<{ show: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 0.3s;
  opacity: 0;
  overflow: hidden;
  z-index: -1;
  width: 100%;
  height: 100%;

  ${({ show }) =>
    show &&
    `
        z-index: 300;
        opacity: 1;
    `}
`;
export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
`;

export const Modal = styled.div`
  background-color: white;
  border-radius: 10px;
`;

export const ModalContent = styled.div`
  padding: 0 40px 40px 40px;
`;

export const CloseIconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 18px;
  padding-bottom: 12px;
  padding-right: 25px;
`;

export const CloseIcon = styled(Close)`
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;
